import { Widget } from '../widget/widget.js';

export class CheckboxWidget extends Widget {
    getChecked(): NodeList {
        return this.$node.querySelectorAll('input:checked');
    }

    async validate(): Promise<boolean> {
        this.clearError();

        let valid = true;

        if (this.required && this.getChecked().length === 0) {
            this.displayError('widget.is_required');
            valid = false;
        }

        return valid;
    }

    async getValue(): Promise<string[]> {
        return Array.from(this.getChecked()).map((v: HTMLInputElement) => v.value);
    }

    listen(action: string, fn: (e: Event) => void): void {
        this.$node.querySelectorAll('input').forEach(i => i.addEventListener(action, fn));
    }
}
